import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

export const CheckCircleStyle = styled.div<
  PropsWithChildren<{ selected: boolean; size: number }>
>`
  border: 1px solid ${(props) => props.theme.palette.divider};
  background-color: ${(props) => props.theme.palette.background.default};
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
`;
